import React from "react";
import { MathJax } from "better-react-mathjax";

export default function MathjaxComponent({
  data,
  styles,
}: {
  data: string;
  styles?: string;
}) {
  
  return (
    <div className={styles}>
      <MathJax dynamic>
        <p dangerouslySetInnerHTML={{ __html: data }}></p>
      </MathJax>
    </div>
  );
}
